// extracted by mini-css-extract-plugin
export var bigImage = "index-module--bigImage--IPRel";
export var container = "index-module--container--2bjnN";
export var customerContainer = "index-module--customerContainer--JFWMs";
export var image = "index-module--image--cSEqo";